/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Something went wrong. Please try again." |
*
* @param {Common_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const common_error_generic = /** @type {((inputs?: Common_Error_GenericInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_GenericInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas ist schiefgelaufen. Bitte versuche es erneut.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une erreur est survenue. Veuillez réessayer.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("出了点问题。请重试。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("發生錯誤，請再試一次。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("문제가 발생했습니다. 다시 시도해 주세요.")
	return /** @type {LocalizedString} */ ("Something went wrong. Please try again.")
});